<template>
  <div v-if="!loading" class="user_wrap" :class="{ 'pt-40': isAndroid }">
    <div class="title_wrap flex-center">
      <span class="title">{{ $t('checkUserInfo.title') }}</span>
    </div>
    <div v-if="showEmpty" class="empty_wrap flex-col-center">
      <div class="flex-col-center empty_wrap">
        <img src="../assets/empty.png" class="empty_icon" alt="" />
        <span class="empty_text">
          {{ $t('checkUserInfo.emptyInfoNote') }}
        </span>
      </div>
    </div>
    <div v-else>
      <Tip class="tip_title" :content="$t('checkUserInfo.infoNote')" :clearable="false" />
      <div class="account_info">
        <div class="info_item">
          <p class="info_label">{{ $t('checkUserInfo.lastSuccessWithdrawal') }}</p>
          <p class="info_value">{{ info.lastSuccessAccount }}</p>
        </div>
        <div class="info_item">
          <p class="info_label">{{ $t('common.firstName') }}</p>
          <p class="info_value">{{ info.firstName }}</p>
        </div>
        <div class="info_item">
          <p class="info_label">{{ $t('common.middleName') }}</p>
          <p class="info_value">{{ info.middleName }}</p>
        </div>
        <div class="info_item">
          <p class="info_label">{{ $t('common.lastName') }}</p>
          <p class="info_value">{{ info.lastName }}</p>
        </div>
      </div>
      <van-button class="btn" block @click="copyToClipboard">
        {{ $t('checkUserInfo.copyBtn') }}
      </van-button>
    </div>
  </div>
</template>
<script>
import Tip from '@/components/LinkAccount/Tip.vue'
export default {
  name: 'checkUser',
  components: {
    Tip
  },
  data() {
    return {
      info: {
        firstName: '',
        middleName: '',
        lastName: '',
        lastSuccessAccount: ''
      },
      loading: false,
      showEmpty: false
    }
  },
  computed: {
    isLogin() {
      return (
        this.$store.state.userInfo &&
        this.$store.state.userInfo.hasOwnProperty('userId') &&
        localStorage.getItem('token')
      )
    },
    isAndroid() {
      const userAgent = navigator.userAgent
      return /Android/i.test(userAgent)
    }
  },
  methods: {
    getUserLastWithdrawInfo() {
      sessionStorage.setItem('isToCheckUserInfo', true)
      let data = {
        userId: this.$store.state.userInfo.userId
      }
      const $this = this
      this.$http
        .post(window.serverPath + '/api/user/getCheckUserInfo', data)
        .then(function (res) {
          const data = res.data
          if (data && data.code === '200') {
            $this.info = data.data
            sessionStorage.removeItem('isToCheckUserInfo')
            $this.showEmpty = false
          } else if (data.code === '40210') {
            $this.showEmpty = true
            $this.logout()
          }
          $this.loading = false
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    gotoLogin() {
      sessionStorage.setItem('isToCheckUserInfo', true)
      const len = history.length
      history.go(-len)
      this.$router.replace({ name: 'beforeLogin' }).then(() => {
        this.$store.commit('delUserInfo')
      })
    },
    goMatwallet() {
      sessionStorage.removeItem('isToCheckUserInfo')
      this.$router.push({
        name: 'Home'
      })
    },
    goBack() {
      window.close()
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(JSON.stringify(this.info))
        this.$toast(this.$t('checkUserInfo.successToast'))
      } catch (err) {
        const input = document.createElement('input')
        input.style.position = 'absolute'
        input.style.left = '-9999px'
        input.value = JSON.stringify(this.info)
        document.body.appendChild(input)
        input.select()
        try {
          const successfulCopy = document.execCommand('copy')
          if (successfulCopy) {
            this.$toast(this.$t('checkUserInfo.successToast'))
          } else {
            this.$toast(this.$t('checkUserInfo.failToast'))
          }
        } catch (e) {
          this.$toast(this.$t('checkUserInfo.failToast'))
        }
        document.body.removeChild(input)
      }
      this.logout()
    },
    logout() {
      const $this = this
      this.$http
        .post(window.serverPath + '/api/auth/logout')
        .then((res) => {
          $this.$store.commit('clearState')
          localStorage.removeItem('token')
          localStorage.removeItem('store')
          // localStorage.removeItem("to_logined")
          this.$router.push('/before-login')
        })
        .catch((err) => console.log('退出失败', err))
    }
  },
  created() {
    if (!this.isLogin) {
      this.gotoLogin()
    } else if (!sessionStorage.getItem('isClearedHistory') && history.length > 1) {
      // 清空历史路由，方便返回的时候直接返回商户端
      this.loading = true
      const len = history.length - 1
      history.go(-len)
      window.location.replace('/check-user-info')
      sessionStorage.setItem('isClearedHistory', true)
      this.getUserLastWithdrawInfo()
    } else {
      this.loading = true
      this.getUserLastWithdrawInfo()
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('isClearedHistory')
  }
}
</script>
<style scoped>
.flex-col-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.empty_wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.empty_icon {
  width: 1.2rem;
  height: 1.2rem;
  flex-shrink: 0;
}

.empty_text {
  margin-top: 0.12rem;
  width: 3.29rem;
  color: #443956;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.user_wrap {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
}

.pt-40 {
  padding-top: 0.4rem;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.title_wrap {
  position: relative;
  width: 100%;
  height: 0.44rem;
  flex-shrink: 0;
}

.back_arrow {
  position: absolute;
  left: 0.18rem;
  width: 0.16rem;
  height: 0.16rem;
  flex-shrink: 0;
}

.title {
  color: #443956;
  font-family: 'PingFang SC';
  font-size: 0.18rem;
  font-style: normal;
  font-weight: 600;
}

.tip_info {
  justify-content: left;
  margin: 0.2rem 0.2rem 0.15rem;
  color: #ff4c62;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.tip_icon {
  margin-inline-end: 0.04rem;
  width: 0.12rem;
  height: 0.12rem;
}

.account_info {
  margin: 0 0.16rem;
}

.info_item {
  display: flex;
  justify-content: space-between;
  align-items: start;
  box-sizing: border-box;
  padding: 0.19rem 0;
  position: relative;
  min-height: 0.6rem;
}

.info_item::after {
  content: '';
  width: 100%;
  height: 1px;
  background: #efefef;
  position: absolute;
  bottom: 0;
  left: 0;
}

.info_label {
  width: 2.2rem;
  text-align: left;
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
}

.info_value {
  flex: 1 0 0;
  text-align: left;
  word-wrap: break-word;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
  word-break: break-all;
  text-align: end;
}

.btn {
  margin-top: 0.12rem;
  margin: 0.12rem 0.16rem;
  width: calc(100% - 0.32rem);
  height: 0.5rem;
  border-radius: 0.08rem;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%), rgba(0, 0, 0, 0.9);
  color: #fff;
  font-family: 'PingFang SC';
  font-size: 0.18rem;
  font-style: normal;
  font-weight: 600;
  border: none;
}

.empty_btn {
  margin-top: 1.94rem;
}
.tip_title {
  height: auto !important;
  margin: 0.18rem 0.16rem 0.12rem 0.16rem !important;
}
</style>



// WEBPACK FOOTER //
// src/views/checkUserInfo.vue